module.exports = __webpack_public_path__ + "static/media/IMG20250119163450.24b60cd6.jpg";